<a tabindex="0" class="link-discreet js-click-on-enter" id="leave-message-link">Leave a message for {{teacherScreenName}}</a>
<div class="donationMessages comment-form form-redux js-donor-comment-form">
    <div class="proposalMessageFormSubmissionErrors" id="proposalMessageFormSubmissionErrors"></div>
    <div class="pm" id="replyForm" data-teacher="{{teacherScreenName}}">

        <form method="post" id="addAMessageForm">
            <div class="input-holder">
                <div class="content" id="messageEdit">
                    <label for="message">Leave a message for {{teacherScreenName}}</label>
                    <textarea name="message" id="message"></textarea>
                </div>
                <div class="content message-preview" id="messagePreview">
                    {{!-- Response section --}}
                    {{!-- Keep in sync with TeacherProposalMessageForm --}}
                    {{{userAvatar author ''}}}
                    <div class="activity-description">
                        <p>
                            {{#if author.anonymous}}
                                <strong>A donor</strong>
                                {{#if author.state}}
                                    from {{author.state}}
                                {{/if}}
                            {{else}}
                                {{#if author.teacherScreenName}}
                                    {{author.teacherScreenName}}
                                {{else}}
                                    {{#if author.familiarDonorGreeting}}
                                        {{author.familiarDonorGreeting}}
                                        {{~else~}}
                                        A donor
                                    {{~/if~}}{{locationAndDonorTeacherRelationship author true undefined}}
                                {{/if}}
                            {{/if}}
                            {{#if teacherResponse}}
                                responded
                            {{/if}}
                        </p>
                    </div>
                    {{!-- End response section --}}
                    <div class="comment"></div>
                </div>
            </div>

            <div id="submitHolder">
                <div id="buttonList" class="input-holder inline-button">
                    <p class="pleaseReview text-discreet" id="pleaseReview">Please review your message above. After you publish, you will not be able to edit or remove your message.</p>
                    <input type="submit" class="button-secondary small js-preview-message disabled js-click-on-enter" name="submit" id="submit" value="Preview"/>
                    <input type="submit" class="button-primary small js-click-on-enter publish-button js-publish-button" name="publish" id="publish" value="Publish" disabled="true"/>
                    <input type="submit" class="button-secondary small js-click-on-enter cancel-button js-cancel-button" name="cancel" id="cancel" value="Cancel"/>
                </div>
            </div>
        </form>

    </div>
</div>


